define.alias("checkout/components/add-ons/change", "calendar/components/add-ons/change");